import React from "react";
import { useState } from "react";

// Modernus, plokščias aplanko ženkliukas — spalva atitinka temą (violetinė primary),
// pakeičia buvusį 📁 emoji, kurio spalvos negalima priderinti prie dizaino.
function FolderIcon({ size = 14, color = 'var(--ral3000)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" style={{flexShrink:0}} xmlns="http://www.w3.org/2000/svg">
      <path d="M2 5.5C2 4.67157 2.67157 4 3.5 4H7.17157C7.70201 4 8.21071 4.21071 8.58579 4.58579L9.41421 5.41421C9.78929 5.78929 10.2979 6 10.8284 6H16.5C17.3284 6 18 6.67157 18 7.5V14.5C18 15.3284 17.3284 16 16.5 16H3.5C2.67157 16 2 15.3284 2 14.5V5.5Z" fill={color}/>
    </svg>
  );
}

export function ProjectsSidebar({ projects, setProjects, activeProjectId, setActiveProjectId,
          selectedDrawingId, onSelectDrawing, onDeleteDrawing, fileInputRef, onUploadClick }) {
          const [showNew, setShowNew] = useState(false);
          const [newName, setNewName] = useState('');
          const [renamingId, setRenamingId] = useState(null);
          const [renameVal, setRenameVal] = useState('');

          function addProject() {
            if (!newName.trim()) return;
            const id = Date.now();
            setProjects(prev => [...prev, {
              id, title: newName.trim(),
              takeoffTemplates: [], takeoffTemplateGroups: [], takeoffDrawings: [],
              takeoffMarkings: [], takeoffLayers: [], takeoffRooms: [], takeoffCalibrations: {}
            }]);
            setActiveProjectId(id);
            setExpandedProjectId(id);
            setNewName(''); setShowNew(false);
          }

          function delProject(id) {
            if (projects.length <= 1) { alert('Negalima ištrinti paskutinio projekto.'); return; }
            if (!window.confirm('Ištrinti projektą? Visi brėžiniai ir žymėjimai bus prarasti.')) return;
            setProjects(prev => prev.filter(p => p.id !== id));
            const fallbackId = projects.find(p => p.id !== id)?.id || null;
            if (activeProjectId === id) setActiveProjectId(fallbackId);
            if (expandedProjectId === id) setExpandedProjectId(fallbackId);
          }

          function saveRename(id) {
            if (!renameVal.trim()) { setRenamingId(null); return; }
            setProjects(prev => prev.map(p => p.id === id ? {...p, title: renameVal.trim()} : p));
            setRenamingId(null);
          }

          // Brėžinys visada priklauso konkrečiam projektui — įkėlimas nukreipiamas
          // į TĄ projektą (padaromas aktyviu), tada atidaromas failo pasirinkimas.
          function uploadIntoProject(projectId) {
            setActiveProjectId(projectId);
            onUploadClick();
          }

          // Išskleidimas — atskira būsena nuo "aktyvus projektas", kad kortelę
          // būtų galima susiskleisti net jei jos projektas tebėra aktyvus.
          const [expandedProjectId, setExpandedProjectId] = useState(activeProjectId);
          function toggleProject(p) {
            setActiveProjectId(p.id);
            setExpandedProjectId(prev => prev === p.id ? null : p.id);
          }

          const [open, setOpen] = useState(false);

          return (
            <div style={{width:open?230:31,minWidth:open?230:31,background:'#fff',borderRight:'1px solid #e5e7eb',display:'flex',flexDirection:'column',height:'calc(100vh - 120px)',transition:'width .2s,min-width .2s',flexShrink:0,overflow:'hidden'}}>

              {/* Suskleidimo juosta */}
              {!open && (
                <div onClick={()=>setOpen(true)}
                  style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',cursor:'pointer',userSelect:'none',gap:6,
                    margin:'8px 4px',background:'var(--ral3000-subtle)',border:'1.5px solid var(--ral3000-light)',
                    borderRadius:10,boxShadow:'0 1px 3px rgba(115,93,255,0.12)'}}
                  title="Išskleisti projektus">
                  <FolderIcon size={15} />
                  <span style={{fontSize:11,fontWeight:700,color:'var(--ral3000)',writingMode:'vertical-rl',textOrientation:'mixed',letterSpacing:1.2,transform:'rotate(180deg)'}}>PROJEKTAI</span>
                </div>
              )}

              {open && <>
              {/* ── Projektai antraštė ── */}
              <div style={{padding:'8px 10px 5px',borderBottom:'1px solid #f0f0f0',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
                <span style={{fontSize:11,fontWeight:800,color:'#1c1c1c',letterSpacing:0.5,display:'flex',alignItems:'center',gap:5}}><FolderIcon size={13} /> PROJEKTAI</span>
                <div style={{display:'flex',gap:3,alignItems:'center'}}>
                  <button onClick={()=>setShowNew(v=>!v)}
                    style={{background:'#735DFF',color:'#fff',border:'none',borderRadius:5,padding:'2px 7px',fontSize:11,fontWeight:700,cursor:'pointer'}}>+</button>
                  <button onClick={()=>setOpen(false)} title="Sutraukti"
                    style={{background:'none',border:'none',cursor:'pointer',fontSize:13,color:'#9ca3af',padding:'0 2px',lineHeight:1}}>◀</button>
                </div>
              </div>

              {showNew && (
                <div style={{padding:'6px 8px',borderBottom:'1px solid #f0f0f0',background:'#fff8f6',flexShrink:0}}>
                  <input autoFocus value={newName} onChange={e=>setNewName(e.target.value)}
                    placeholder="Projekto pavadinimas..."
                    onKeyDown={e=>{if(e.key==='Enter')addProject();if(e.key==='Escape'){setShowNew(false);setNewName('');}}}
                    style={{width:'100%',border:'1px solid #e5e7eb',borderRadius:5,padding:'4px 7px',fontSize:11,boxSizing:'border-box',marginBottom:4}}/>
                  <div style={{display:'flex',gap:4}}>
                    <button onClick={addProject} style={{flex:1,background:'#735DFF',color:'#fff',border:'none',borderRadius:5,padding:'3px',fontSize:11,fontWeight:700,cursor:'pointer'}}>Sukurti</button>
                    <button onClick={()=>{setShowNew(false);setNewName('');}} style={{background:'#f3f4f6',border:'none',borderRadius:5,padding:'3px 7px',fontSize:11,cursor:'pointer'}}>✕</button>
                  </div>
                </div>
              )}

              {/* ── Projektų sąrašas — kiekvienas išskleidžiamas, viduje jo brėžiniai ── */}
              <div style={{flex:1,overflowY:'auto',padding:'4px'}}>
                {projects.map(p => {
                  const isActive = p.id === activeProjectId;
                  const isExpanded = p.id === expandedProjectId;
                  const drawings = p.takeoffDrawings || [];
                  return (
                    <div key={p.id}
                      style={{marginBottom:5,borderRadius:8,border:'1px solid '+(isActive?'var(--ral3000)':'#e5e7eb'),overflow:'hidden'}}>

                      {/* Projekto antraštė — paspaudus tampa aktyvus; pati kortelė išsi/susiskleidžia */}
                      <div onClick={()=>toggleProject(p)}
                        style={{padding:'6px 7px',display:'flex',alignItems:'center',gap:5,cursor:'pointer',
                          background:isActive?'var(--ral3000-subtle)':'#fff'}}>
                        <span style={{fontSize:9,color:isActive?'var(--ral3000)':'#9ca3af',flexShrink:0,
                          transform:isExpanded?'rotate(90deg)':'none',transition:'transform .15s',display:'inline-block'}}>▶</span>
                        {renamingId === p.id ? (
                          <input autoFocus value={renameVal} onChange={e=>setRenameVal(e.target.value)}
                            onClick={e=>e.stopPropagation()}
                            onKeyDown={e=>{if(e.key==='Enter')saveRename(p.id);if(e.key==='Escape')setRenamingId(null);}}
                            style={{flex:1,minWidth:0,border:'1px solid #e5e7eb',borderRadius:4,padding:'3px 5px',fontSize:11,boxSizing:'border-box'}}/>
                        ) : (
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:11,fontWeight:isActive?800:600,color:isActive?'var(--ral3000)':'#1c1c1c',
                              overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{p.title}</div>
                            <div style={{fontSize:9,color:'#9ca3af'}}>
                              {drawings.length} brėž. · {(p.takeoffMarkings||[]).length} žym.
                            </div>
                          </div>
                        )}
                        <div style={{display:'flex',flexShrink:0}} onClick={e=>e.stopPropagation()}>
                          <button onClick={()=>{setRenamingId(p.id);setRenameVal(p.title);}}
                            style={{background:'none',border:'none',cursor:'pointer',fontSize:11,color:'#d1d5db',padding:'1px 2px'}}>✏</button>
                          <button onClick={()=>delProject(p.id)}
                            style={{background:'none',border:'none',cursor:'pointer',fontSize:13,color:'#d1d5db',padding:'1px 2px'}}>×</button>
                        </div>
                      </div>

                      {/* Išskleistas turinys — šio projekto brėžiniai */}
                      {isExpanded && (
                        <div style={{borderTop:'1px solid #f0f0f0',background:'#fafbfc'}}>
                          <div style={{padding:'6px 7px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                            <span style={{fontSize:10,fontWeight:800,color:'#1c1c1c',letterSpacing:0.5}}>📐 BRĖŽINIAI</span>
                            <button onClick={()=>uploadIntoProject(p.id)}
                              style={{background:'#383853',color:'#fff',border:'none',borderRadius:5,padding:'2px 7px',fontSize:11,fontWeight:700,cursor:'pointer'}}>+ PDF</button>
                          </div>
                          <div style={{maxHeight:220,overflowY:'auto',padding:'0 0 4px'}}>
                            {drawings.length === 0 && (
                              <div style={{padding:'10px 8px',fontSize:10,color:'#9ca3af',textAlign:'center'}}>Nėra brėžinių.<br/>Įkelkite PDF.</div>
                            )}
                            {drawings.map(d => (
                              <div key={d.id} style={{display:'flex',alignItems:'center',gap:3,padding:'5px 8px',cursor:'pointer',margin:'1px 5px',borderRadius:5,
                                background:selectedDrawingId===d.id?'#f0f0f2':'transparent',
                                borderLeft:'3px solid '+(selectedDrawingId===d.id?'#383853':'transparent')}}
                                onClick={()=>onSelectDrawing(d.id)}>
                                <div style={{flex:1,minWidth:0}}>
                                  <div style={{fontSize:11,fontWeight:selectedDrawingId===d.id?700:500,color:'#1c1c1c',
                                    whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{d.name}</div>
                                  {d.totalPages > 1 && <div style={{fontSize:9,color:'#9ca3af'}}>Lapas {d.pageNum}/{d.totalPages}</div>}
                                </div>
                                <button onClick={e=>{e.stopPropagation();onDeleteDrawing(d.id);}}
                                  style={{background:'none',border:'none',color:'#d1d5db',cursor:'pointer',fontSize:13,flexShrink:0,padding:'0 1px'}}>×</button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              </>}
            </div>
          );
        }
